import {LoadingOutlined} from "@ant-design/icons"
import {Checkbox, message, Rate} from "antd"
import { observer } from "mobx-react-lite"
import moment from "moment"
import { FC, useContext, useEffect, useRef, useState } from "react"
import {Context} from "../.."
import {ApiService} from "../../core/api/api"
import useWindowDimensions from "../../core/hooks/useWindowDimensions"
import {declOfNum, distanceLatLon, isNullOrUndefined, prevent} from "../../core/utils/utils"
import RubbleIcon from "../icons/RubbleIcon"
import ConfirmModal from "./shared/ConfirmModal"
import BarberCard from "./shared/BarberCard"
import Calendar from "./shared/calendar/Calendar"
import CompanyCard from "./shared/CompanyCard"
import RecordCard from "./shared/RecordCard"
import ServiceCard from "./shared/ServiceCard"

import InputMask from 'react-input-mask'

import styles from "./styles/YClientsWidget.module.scss"
import stylesSt from "../../styles/Loyalty/Statuses.module.scss"
import {StorageKeys} from "../../core/utils/defaults"
import Geolocator from "./shared/Geolocator"
import BottomModal from "../modals/BottomModal"
import {getSubName} from "../../core/utils/loyalty"
import Modal from "../Modal"
import {DebounceInput} from "react-debounce-input"
import IconsPack from "../icons/IconsPack"

import { YMaps, Map, Placemark, useYMaps } from '@pbe/react-yandex-maps'

interface YClientsWidgetProps {
  yclients_id?: number
  barber_id?: number
  visible: boolean
  preserveCompany?: number
  preserveBarber?: number
  onClose: () => void
  onStageChanged?: (stage: number) => void
  onOrderCreated?: () => void
  onOpenSubscribe?: () => void
}

type WHMode = "ru" | "plus"

const WIDGET_HOST_MODE: string = "ru"

const YClientsWidget: FC<YClientsWidgetProps> = ({
  yclients_id = 0, barber_id = 0, visible, onClose, onStageChanged, onOrderCreated, onOpenSubscribe
}) => {

  const { store, loyaltyStore } = useContext(Context)

  const { width } = useWindowDimensions()

  const mapRef = useRef(null as any)
  const ymaps = useYMaps(['Map', 'Layer', 'MapType', 'Placemark', 'Clusterer', 'ObjectManager'])
  
  const [stage, setStage] = useState(0)

  const [phone, setPhone] = useState("")
  const [code, setCode] = useState("")
  const [authState, setAuthState] = useState("phone" as "phone" | "code")

  const [prePreVisible, setPrePreVisible] = useState(false)
  const [preVisible, setPreVisible] = useState(false)
  const [visibleA, setVisibleA] = useState(false)

  const [isCompInfoVisible, setIsCompInfoVisible] = useState(false)
  const [selectedPrize, setSelectedPrize] = useState(null as any | null)
  const [isGiftsVisible, setIsGiftsVisible] = useState(false)
  const [isGiftsLoading, setIsGiftsLoading] = useState(false)
  
  const [isAccepted, setIsAccepted] = useState(false)

  const [rate, setRate] = useState(5)
  const [comment, setComment] = useState("")
  const [tipsCount, setTipsCount] = useState(500)
  const [tipsCountTxt, setTipsCountTxt] = useState("")
  const [tipsInfoVisible, setTipsInfoVisible] = useState(false)
  const [servsInfoVisible, setServsInfoVisible] = useState(false)
  const [isSendingReview, setIsSendingReview] = useState(false)
  
  const [isWidgetVisible, setIsWidgetVisible] = useState(false)
  const [isWidgetShown, setIsWidgetShown] = useState(false)
  
  const [isTPZShown, setIsTPZShown] = useState(true)

  const [isDataLoading, setIsDataLoading] = useState(true)
  const [isDtLoading, setIsDtLoading] = useState(false)
  
  const [isOrderCreateVisible, setIsOrderCreateVisible] = useState(false)
  const [isOrderCancelVisible, setIsOrderCancelVisible] = useState(false)
  const [isOrderLoadingShown, setIsOrderLoadingShown] = useState(false)
  const [isOrderLoadingVisible, setIsOrderLoadingVisible] = useState(false)
  
  const [companies, setCompanies] = useState([] as any[])
  const [companiesFilter, setCompaniesFilter] = useState([] as any[])
  const [searchCompany, setSearchCompany] = useState("")
  
  const [loyaltyUser, setLoyaltyUser] = useState(null as any | null)
  const [loyaltyBarber, setLoyaltyBarber] = useState(null as any | null)
  const [barber, setBarber] = useState(null as any | null)
  const [userName, setUserName] = useState("")
  const [userPhone, setUserPhone] = useState("")
  const [userCode, setUserCode] = useState("")
  const [userEmail, setUserEmail] = useState("")
  const [isUserPhoneError, setIsUserPhoneError] = useState(false)
  const [isUserPhoneLoading, setIsUserPhoneLoading] = useState(false)
  
  const [isSendCodeLoading, setIsSendCodeLoading] = useState(false)
  const [isSignLoading, setIsSignLoading] = useState(false)
  
  const [whatSmsGet, setWhatSmsGet] = useState("sms")

  const [barbers, setBarbers] = useState([] as any[])
  const [dates, setDates] = useState([] as any[])
  const [availableDates, setAvailableDates] = useState([] as any[])
  const [availableTimes, setAvailableTimes] = useState([] as any[])
  const [times, setTimes] = useState([] as any[])
  const [services, setServices] = useState([] as any[])

  const [selectedDate, setSelectedDate] = useState(moment())
  const [selectedDateStr, setSelectedDateStr] = useState("")
  const [selectedDateStr2, setSelectedDateStr2] = useState("")
  const [selectedTime, setSelectedTime] = useState(null as any | null)
  const [selectedCompany, setSelectedCompany] = useState(null as any | null)
  const [selectedBarber, setSelectedBarber] = useState(null as any | null)
  const [selectedOrder, setSelectedOrder] = useState(null as any | null)
  const [selectedServices, setSelectedServices] = useState([] as any[])
  
  // const [actualVisits, setActualVisits] = useState([] as any[])

  const [activeSub, setActiveSub] = useState(null as any | null)
  const [bonusCard, setBonusCard] = useState(null as any | null)
  const [bonuses, setBonuses] = useState(0)
  const [servsTab, setServsTab] = useState(0)
  const [listTab, setListTab] = useState(0)
  const [lUser, setLUser] = useState(null as any | null)
  const [isLogoutVisible, setIsLogoutVisible] = useState(false)

  const onOpenRef = () => {
    const html = document.getElementsByTagName("html")
    html[0].style.overflowY = "hidden"
    
    const loc = localStorage.getItem(StorageKeys.USER_LOCATION)
    if (loc == null) {
      store.setIsLocatorVisible(true)
    } else {
      store.setLocation(JSON.parse(loc))
    }

    loadActuals()

    setIsWidgetShown(true)
    setTimeout(() => {
      setIsWidgetVisible(true)
    }, 100)
  }

  const onCloseRef = () => {
    const html = document.getElementsByTagName("html")
    html[0].style.overflowY = "scroll"
    
    setIsWidgetVisible(false)
    setTimeout(() => {
      setIsWidgetShown(false)
    }, 300)
  }

  const loadActuals = async () => {
    if (store.isAuth) {
      setIsDtLoading(true)

      const res = await ApiService.widget.getLastOrders()

      console.log(res)

      setIsDtLoading(false)

      if (res.data.state == 1) {
        store.setActualVisits(res.data.orders)
        if (selectedOrder != null) {
          setSelectedOrder(prev => prev = null)
          setStage(prev => prev = 0)
        }
      } else {
        store.setActualVisits([])
      }
    }
  }

  const sendReview = async () => {
    setIsSendingReview(true)

    if (tipsCount > 0 && tipsCount <= 2000 && loyaltyBarber != null) {
      const res1 = await ApiService.widget.createTips({
        count: tipsCount > 0 ? tipsCount : parseInt(tipsCountTxt),
        barber_id: loyaltyBarber.id,
        order_id: selectedOrder.order.id
      })

      if (res1.data.state == 0) {
        message.error(res1.data.message)
      } else if (res1.data.state == 1) {
        message.success("Чаевые успешно отправлены!")
      } else if (res1.data.state == 2) {
        message.warning(res1.data.message)
      }
    }

    const res = await ApiService.widget.createReview({
      order_id: selectedOrder.order.id,
      rating: rate,
      review: comment
    })

    if (loyaltyBarber != null) {

    }

    message.success("Отзыв успешно отправлен!")

    setSelectedOrder(prev => prev = null)
    setStage(prev => prev = 0)

    await loadActuals()

    // setIsSendingReview(false)
  }

  const createOrder = async () => {
    setIsDataLoading(prev => prev = true)

    // setStage(prev => prev = 1)

    const res = await ApiService.widget.getCompanies()

    console.log(res)

    let lst: any[] = res.data.companies.data

    // if (store.userData.source == "topgun") {
      lst = lst.filter(v => (v.title.toLowerCase().includes("топган ") || v.title.toLowerCase().includes("topgun ") || v.title.toLowerCase().includes("individual ") || v.title.toLowerCase().includes("fidel ")) && v.title != "TOPGUN УК")
    // } else {
    //   lst = lst.filter(v => v.title.toLowerCase().includes("fidel "))
    // }

    // lst = lst.sort((a, b) => {
    //   let latA = a.coordinate_lat
    //   let lonA = a.coordinate_lon

    //   let latB = b.coordinate_lat
    //   let lonB = b.coordinate_lon

    //   let dA = distanceLatLon(latA, lonA, store.locationCoords[0], store.locationCoords[1], "K")
    //   let dB = distanceLatLon(latB, lonB, store.locationCoords[0], store.locationCoords[1], "K")

    //   return dA > dB ? -1 : (dA < dB ? 1 : 0)
    // })

    lst = lst.map((v: any) => {
      let dstx = store.locationCoords.length > 0 ? distanceLatLon(v.coordinate_lat, v.coordinate_lon, store.locationCoords[0], store.locationCoords[1], "K") : 0
      return {
        ...v, distance: dstx
      }
    })

    lst = lst.sort((a, b) => {
      return a.distance > b.distance ? 1 : (a.distance < b.distance ? -1 : 0)
    })

    setCompanies(prev => prev = lst)
    setCompaniesFilter(prev => prev = lst)

    if (yclients_id != 0) {
      let item = lst.find(v => v.id == yclients_id)
      console.log(item)
      if (item != undefined) {
        setTimeout(() => {
          setSelectedCompany(prev => prev = null)
          setTimeout(() => {
            setSelectedCompany(prev => prev = item)

            if (barber_id != 0) {

            } else {
              setStage(prev => prev = 2)
            }
          }, 100)
        }, 150)
      }
    } else {
      setStage(prev => prev = 1)
    }

    setIsDataLoading(prev => prev = false)
  }

  const filterCompanies = () => {
    let lst: any[] = [...companies]
    lst = lst.filter(v => {
      if (searchCompany != "") {
        let search = searchCompany.toLowerCase()
        return v.title.toLowerCase().includes(search) || v.city.toLowerCase().includes(search) || v.address.toLowerCase().includes(search)
      }
      return true
    })
    setCompaniesFilter(prev => prev = lst)
  }

  const loadBarbers = async () => {
    setIsDataLoading(prev => prev = true)
    setStage(prev => prev = 2)
    
    // const res = await ApiService.widget.getCompanyStaff(selectedCompany.id)

    // console.log(res)

    let lst: any[] = selectedCompany.staff_list

    lst = lst.filter(v => v.hidden == 0)

    let lstFin: any[] = []

    lst.forEach(stf => {
      let stfx: any = {...stf}
      if (stf.pre_dates == null) {
        return
      }
      let dts = stf.pre_dates.data
      let now = moment().format("YYYY-MM-DD")
      let dates: any[] = []
      let datesX: any[] = []
      let ix = 0
      dts.forEach(dt => {
        let nt1 = parseInt(dt.replace("-", "").replace("-", ""))
        let nt2 = parseInt(now.replace("-", "").replace("-", ""))

        if (nt1 >= nt2) {
          if (ix < 3) {
            dates.push(dt)
            datesX.push(nt1 == nt2 ? "Сегодня" : moment(dt).format("DD MMM"))
            ix++
          }
        }

      })
      stfx.dates_formatted = dates
      stfx.dates = datesX
      lstFin.push(stfx)
    })

    console.log(lstFin)

    setBarbers(prev => prev = lstFin)

    if (barber_id != 0) {
      let item = lstFin.find(v => v.id == barber_id)
      console.log(item)
      if (item != undefined) {
        setTimeout(() => {
          setSelectedBarber(prev => prev = null)
          setTimeout(() => {
            setSelectedBarber(prev => prev = item)

            setStage(prev => prev = 3)
          }, 100)
        }, 150)
      }
    }

    setIsDataLoading(prev => prev = false)
  }

  const loadBarberServices = async () => {
    setIsDataLoading(prev => prev = true)
    setStage(prev => prev = 3)
    
    console.log("selectedCompany")
    console.log(selectedCompany)
    const res = await ApiService.widget.getStaffServices(selectedCompany.id, selectedBarber.id)

    console.log(res)

    let lst: any[] = res.data.services.data

    lst = lst.filter(v => v.active == 1)

    let lst1: any = []
    lst.forEach(serv => {
      let el: any = {...serv}
      if (!isNullOrUndefined(serv.staff) && serv.staff.length > 0) {
        el.duration = serv.staff[0].seance_length
      }
      lst1.push(el)
    })

    setServices(prev => prev = lst1)

    setIsDataLoading(prev => prev = false)
  }

  const selectService = (service: any) => {
    let sels: any[] = [...selectedServices]
    console.log(service)
    let exist = sels.find(v => v.id == service.id)
    if (exist != undefined) {
      sels = sels.filter(v => v.id != service.id)
    } else {
      sels = [...sels, service]
    }
    setSelectedServices(prev => prev = sels)
  }

  const goCalendar = async () => {
    setIsDataLoading(prev => prev = true)
    setStage(prev => prev = 4)
    
    let nowDate = moment().format("YYYY-MM-DD")
    const res = await ApiService.widget.getStaffDates(selectedCompany.id, selectedBarber.id, nowDate)

    console.log(res)

    let lst: any[] = res.data.dates.data

    setAvailableDates(prev => prev = lst)

    setIsDataLoading(prev => prev = false)
  }

  const goTimetable = async (ev: any) => {
    setIsDataLoading(prev => prev = true)
    setStage(prev => prev = 5)
    
    let selDate = ev.format("YYYY-MM-DD")
    let nowDate = moment().format("YYYY-MM-DD")
    setSelectedDate(ev)
    setSelectedDateStr(ev.format("dddd"))
    setSelectedDateStr2(ev.format("D MMMM"))

    const res = await ApiService.widget.getStaffDateTimes(selectedCompany.id, selectedBarber.id, selDate)

    console.log(res)

    let lst: any[] = res.data.times.data
    let lstFinal: any[] = []
    let lstFinalEnd: any[] = []
    let now = moment().format("HH:mm")

    lst = lst.filter(v => {
      let spl = v.time.split(":")
      if (spl[1] == "00" || spl[1] == "30") {
        return true
      }
      return false
    })

    let duration = getDuration()
    let durationHours = duration / 60 / 60

    lst.forEach((v, ix) => {
      let nexted = null
      if (lst.length > (ix + 2)) {
        nexted = lst[ix]
      }
      console.log("nexted")
      console.log(nexted, duration)

      let spl = v.time.split(":")
      let spl2 = now.split(":")
      
      if (selDate == nowDate) {
        let go = false
        if (parseInt(spl[0]) == parseInt(spl2[0])) {
          if (parseInt(spl[1]) >= parseInt(spl2[1])) {
            if (v.is_free) {
              go = true
            }
          }
          return
        }

        if (parseInt(spl[0]) >= parseInt(spl2[0])) {
          if (v.is_free) {
            go = true
          }
        }

        if (go) {
          lstFinal.push(v)
        }
      } else {
        if (v.is_free) {
          lstFinal.push(v)
        }
      }
    })

    let count = 0
    let temp: any[] = []
    lstFinal.forEach((itm: any) => {
      if (count < 5) {
        temp.push(itm)
        count += 1
      } else {
        lstFinalEnd.push(temp)
        count = 1
        temp = [itm]
      }
    })

    if (temp.length > 0) {
      let ix = 5 - temp.length
      for (let i = 0; i < ix; i++) {
        temp.push({ time: "--:--" })
      }
      lstFinalEnd.push(temp)
    }
    console.log(lstFinalEnd)

    console.log(lstFinal)

    setAvailableTimes(prev => prev = lstFinalEnd)

    setIsDataLoading(prev => prev = false)
  }

  const goFinal = (time: any) => {
    setIsDataLoading(prev => prev = true)
    
    if (WIDGET_HOST_MODE == "ru") {
      if (store.isAuth) {
        setStage(prev => prev = 7)
      } else {
        setStage(prev => prev = 6)
      }
    } else {
      setStage(prev => prev = 7)
    }

    if (store.isAuth) {
      setUserName(store.userData.name)
      setUserPhone(store.userData.phone)
      setUserEmail(store.userData.email)
    }

    // InFuture:
    // if (store.isAuth) {
    //   setStage(prev => prev = 7)
    // } else {
    //   setStage(prev => prev = 6)
    // }

    setSelectedTime(prev => prev = time)

    setIsDataLoading(prev => prev = false)
  }

  const fetchBarber = async () => {
    if (isNullOrUndefined(selectedOrder.result.data.staff)) {
      setStage(prev => prev = 10)
      return
    }

    const res = await ApiService.widget.findBarber(selectedOrder.result.data.staff.id)
    
    if (res.data.finded != null && !isNullOrUndefined(res.data.finded.phone) && res.data.finded.phone != "") {
      setBarber(prev => prev = res.data.finded)
      if (!isNullOrUndefined(res.data.exists_barber)) {
        setLoyaltyBarber(prev => prev = res.data.exists_barber)
      } else {
        let res2 = await ApiService.widget.findClient(res.data.finded.phone)
        if (res2.data.state == 1) {
          setLoyaltyBarber(prev => prev = res2.data.client)
        }
      }
    }
    
    setStage(prev => prev = 10)
  }

  const fetchUser = async () => {
    if (store.isAuth) {
      const res = await ApiService.widget.findClient(store.userData.phone.replaceAll(" ", "").replaceAll("-", ""))
      if (res.data.state == 1) {
        setIsUserPhoneLoading(false)
        setLoyaltyUser(res.data.client)
      }
    }
  }

  const saveUserData = async () => {
    console.log(userPhone)
    if (userPhone != "" && !userPhone.includes("_")) {
      setIsUserPhoneError(false)

      if (WIDGET_HOST_MODE == "ru") {
        setIsUserPhoneLoading(true)
        
        const res = await ApiService.widget.findClient(userPhone.replaceAll(" ", "").replaceAll("-", ""))
        if (res.data.state == 1) {
          setIsUserPhoneLoading(false)
          setLoyaltyUser(res.data.client)
        }

        setStage(prev => prev = 7)
      }

    } else {
      setIsUserPhoneError(true)
    }
  }

  const isServiceSelected = (service: any) => {
    let selected = selectedServices.find(v => v.id == service.id)
    return selected != undefined
  }

  const getServicePrice = (serv: any) => {
    if (serv.price_max == 0) {
      if (!isNullOrUndefined(serv.staff) && serv.staff.length > 0) {
        return serv.staff[0].price.max
      } else {
        return 0
      }
    } else {
      return serv.price_max
    }
  }

  const getTotalPrice = () => {
    return selectedServices.map(v => getServicePrice(v)).reduce((prevState: any, currVal: any, ci: number, arr: any[]) => prevState + arr[ci], 0)
  }

  const getTotalPriceBS = (services: any) => {
    return services.map(v => v.cost_to_pay).reduce((prevState: any, currVal: any, ci: number, arr: any[]) => prevState + arr[ci], 0)
  }

  const createYCLOrder = () => {
    setIsOrderCreateVisible(true)
  }

  const signIn = async () => {
    let phn = phone.replaceAll("+", "").replaceAll(" ", "").replaceAll("-", "")
    console.log(phn)
    
    setIsSignLoading(true)

    const res = await ApiService.loyalty.signInWithCode({login: phn, code: code})

    setIsSignLoading(false)

    if (res.data.state == 1) {
      store.applyMaxmaAuthWCode(res.data)
      store.setIsAuth(true)

      fetchUser()
      setCode("")

      fetchAccount()

      // window.location.href = "/store"
      // setFormViewType(prev => prev = FormViewType.NOTIFY)
    } else {
      setCode("")
      message.error("Неверный проверочный код!")
    }
  }

  const sendCode = async () => {
    let phn = phone.replaceAll(" ", "").replaceAll("-", "")
    console.log(phn)

    const res = await ApiService.loyalty.checkAccount({ phone: phn })

    if (res.data.state == 0 || res.data.state == 2) {
      if (res.data.state == 2) {
        // register()
        let props: any = {
          name: userName,
          surname: "",
          fullname: `${userName}`,
          phone: phn,
          email: userEmail,
          birthdate: selectedDateStr,
          birthday: selectedDateStr,
          gender: 0,
          login: phn,
          role: "USER",
          status: 1,
          email_subscribed: false,
          phone_subscribed: false
        }

        const res = await ApiService.loyalty.signUpWithMaxma(props)

        if (res.data.state == 1 || res.data.state == 2) {
          
    
          if (res.data.state == 1) {
            // store.setSmsCode(res.data.code)
            // setFormViewType(prev => prev = FormViewType.CODE)
            message.success("Теперь введите код отправленный в смс...")
            setAuthState("code")
          } else {
            store.applyMaxmaAuth(res.data)
            store.setIsAuth(true)
            // window.location.href = "/store"
          }
        } else {
          message.error(res.data.message)
        }

        setIsSendCodeLoading(false)
      }
      return
    } else if (res.data.state == 1) {
      setIsSendCodeLoading(false)
      setAuthState("code")
      if (res.data.is_tg == true) {
        setWhatSmsGet("telegram")
        message.success("Введите код отправленный в Telegram Бота")
      } else {
        message.success("Введите код отправленный в смс")
      }
    }
  }

  const sendCodeAction = async () => {
    setIsOrderCreateVisible(false)

    setStage(prev => prev = 8)

    setIsSendCodeLoading(true)

    let phn = userPhone.replaceAll(" ", "").replaceAll("-", "")
    console.log(phn)

    const res = await ApiService.loyalty.checkAccount({ phone: phn })

    if (res.data.state == 0 || res.data.state == 2) {
      if (res.data.state == 2) {
        // register()
        let props: any = {
          name: userName,
          surname: "",
          fullname: `${userName}`,
          phone: phn,
          email: userEmail,
          birthdate: selectedDateStr,
          birthday: selectedDateStr,
          gender: 0,
          login: phn,
          role: "USER",
          status: 1,
          email_subscribed: false,
          phone_subscribed: false
        }

        const res = await ApiService.loyalty.signUpWithMaxma(props)

        if (res.data.state == 1 || res.data.state == 2) {
          
    
          if (res.data.state == 1) {
            // store.setSmsCode(res.data.code)
            // setFormViewType(prev => prev = FormViewType.CODE)
            message.success("Теперь введите код отправленный в смс...")
          } else {
            store.applyMaxmaAuth(res.data)
            store.setIsAuth(true)
            // window.location.href = "/store"
          }
        } else {
          message.error(res.data.message)
        }

        setIsSendCodeLoading(false)
      }
      return
    } else if (res.data.state == 1) {
      setIsSendCodeLoading(false)
      if (res.data.is_tg == true) {
        setWhatSmsGet("telegram")
        message.success("Введите код отправленный в Telegram Бота")
      } else {
        message.success("Введите код отправленный в смс")
      }
    }
  }

  const signInAction = async () => {
    let phn = userPhone.replaceAll("+", "").replaceAll(" ", "").replaceAll("-", "")
    console.log(phn)
    
    setIsSignLoading(true)

    const res = await ApiService.loyalty.signInWithCode({login: phn, code: userCode})

    setIsSignLoading(false)

    if (res.data.state == 1) {
      store.applyMaxmaAuthWCode(res.data)
      store.setIsAuth(true)

      setUserCode("")

      setIsSendCodeLoading(true)
      createYCLOrderAction()

      // window.location.href = "/store"
      // setFormViewType(prev => prev = FormViewType.NOTIFY)
    } else {
      setUserCode("")
      message.error("Неверный проверочный код!")
    }
  }

  const getDuration = () => {
    let duration = 0

    selectedServices.forEach(srv => {
      duration += srv.duration
    })

    return duration
  }

  const createYCLOrderAction = async () => {
    setIsOrderCreateVisible(false)

    if (!isAccepted) {
      return message.warning("Предоставьте согласие на обработку персональных данных")
    }

    showLoading()

    let duration = 0
    let servs: any[] = []

    selectedServices.forEach(srv => {
      servs.push({
        id: srv.id,
        first_cost: getServicePrice(srv),
        discount: 0,
        cost: getServicePrice(srv)
      })
      duration += srv.duration
    })

    let props: any = {
      company_id: selectedCompany.id,
      company_address: selectedCompany.address,
      order: {
        staff_id: selectedBarber.id,
        client: {
          phone: store.userData.phone,
          name: store.userData.name,
          surname: store.userData.surname,
          email: store.userData.email
        },
        services: servs,
        save_if_busy: false,
        datetime: `${selectedDate.format("YYYY-MM-DD")} ${selectedTime.time}:00`,
        seance_length: duration,
        send_sms: true,
        sms_remain_hours: 2,
        client_agreements: {
          is_newsletter_allowed: true,
          is_personal_data_processing_allowed: true
        },
        attendance: 0,
        custom_color: "9c2af6",
        comment: `Новый виджет онлайн-записи. ${selectedPrize != null ? `В комплимент за достижение статуса в TOPGUN+ выбрана услуга "${selectedPrize.name}" за 0 руб.!` : ""}`
      }
    }

    console.log(props)

    const res = await ApiService.widget.createOrder(props)
    
    if (res.data.state == 0) {
      hideLoading()
      message.warning("Запись на это время невозможна! Выберите меньше услуг или другую дату/время.")
      setTimeout(() => {
        setStage(prev => prev = 5)
      }, 1000)
      return
    }

    await loadActuals()

    setTimeout(() => {
      hideLoading()

      setStage(prev => prev = 0)
    }, 1000)
  }

  const declineOrder = async () => {
    setIsOrderCancelVisible(false)
    showLoading()

    const res = await ApiService.widget.declineOrder(selectedOrder.order.id)

    await loadActuals()

    message.success("Запись успешно отменена")

    setTimeout(() => {
      hideLoading()

      setStage(prev => prev = 0)
      setSelectedOrder(prev => prev = null)
    }, 1000)
  }

  const showLoading = () => {
    setIsOrderLoadingShown(true)
    setTimeout(() => {
      setIsOrderLoadingVisible(true)
    }, 100)
  }

  const hideLoading = () => {
    setIsOrderLoadingVisible(false)
    setTimeout(() => {
      setIsOrderLoadingShown(false)
    }, 400)
  }

  const isOrderStarted = () => {
    if (selectedOrder != null) {
      let orderStart = moment(selectedOrder.result.data.datetime).unix()
      let now = moment().unix()
      if (now >= orderStart) {
        return true
      }
    } 

    return false
  }

  const isOrderEnded = () => {
    if (selectedOrder != null) {
      let orderStart = moment(selectedOrder.result.data.datetime).unix() + 900
      let now = moment().unix()
      if (now > orderStart) {
        return true
      }
    } 

    return false
  }

  const fetchAccount = async () => {
    const res = await ApiService.loyalty.getAccount()

    console.log(res)

    setActiveSub(res.data.user.active_sub)
    setLUser(res.data.user)
    setBonuses(res.data.bonus_data.bonuses)
    setBonusCard(res.data.bonus_data.bonus_card)
  }

  const logout = () => {
    setIsLogoutVisible(true)
  }

  const logoutAction = async () => {
    setStage(prev => prev = 0)
    setIsLogoutVisible(false)
    loadActuals()
    store.logout()
  }

  const closeUser = () => {
    setVisibleA(false)
    setTimeout(() => {
      setPreVisible(false)
      setTimeout(() => {
        setPrePreVisible(false)
      }, 300)
    }, 300)
  }

  const openUser = () => {
    if (store.isAuth) {
      fetchAccount()
    }

    setPrePreVisible(true)
    setTimeout(() => {
      setPreVisible(true)
      setTimeout(() => {
        setVisibleA(true)
      }, 300)
    }, 100)
  }

  useEffect(() => {
    // console.log(mapRef.current, listStyle, isPostsLoading)

    if (!ymaps || mapRef.current == null ||  listTab == 0 || isDataLoading) {
      return
    }

    let cntr = [55.76, 37.64]

    if (companiesFilter.length > 0) {
      if (companiesFilter[0].coordinate_lat != "") {
        // console.log(studioStore.studios[0])
        
        cntr = [companiesFilter[0].coordinate_lat, companiesFilter[0].coordinate_lon]
      }
    }

    const map = new ymaps.Map(mapRef.current, {
      center: cntr,
      zoom: 10,
      
    })
    
    // const layer = new YMapDefaultSchemeLayer({
    //   theme: "dark"
    // })

    const DARK_MAP = 'custom#dark';

    const layer = new ymaps.Layer('https://core-renderer-tiles.maps.yandex.net/tiles?l=map&theme=dark&%c&%l&scale={{ scale }}')

    map.layers.add(layer)

    // map.layers.add(new ymaps.MapType('Dark Map', [DARK_MAP]))

    // console.log(cntr)
    // map.layers.add(function DarkLayer() {
    //     // Ссылка на темные тайлы Яндекс.Карт
    //     // От стандартной отличается наличием &theme=dark
    //     return new ymaps.Layer(
    //       'https://core-renderer-tiles.maps.yandex.net/tiles?l=map&theme=dark&%c&%l&scale={{ scale }}',
    //     )
    //   })
    
    // /* Связываем слой с типом карты */
    // ymaps.layers[0].storage.add(DARK_MAP, new ymaps.MapType('Dark Map', [DARK_MAP]));
    

    const objectManager = new ymaps.ObjectManager({
      // Enabling clustering.
      clusterize: true,
      preset: "islands#blackClusterIcons",
      // Geo object options are set with the "geoObject" prefix.
      geoObjectOpenBalloonOnClick: false
    })

    companiesFilter.forEach(std => {
      // console.log(std.geoloc)
      if (std.coordinate_lat != 0 && std.coordinate_lat != "") {
        // let geo = std.geoloc.split(";")
        const mark = new ymaps.Placemark([std.coordinate_lat, std.coordinate_lon], {
          id: `studio_${std.id}`
        }, {})

        objectManager.add({
          type: 'Feature',
          id: `studio_${std.id}`,
          data: {id: `studio_${std.id}`},
          geometry: {
            type: 'Point',
            coordinates: [std.coordinate_lat, std.coordinate_lon]
          },
          options: {
            iconLayout: 'default#image',
            iconImageHref: 'assets/images/map_place.png',
            width: "24px",
            height: "24px"
            // preset: "islands#blackDotIcon",
            // opacity: 0.2,
            // strokeWidth: 2,
            // fillColor: '#00FF00'
          }    
        })
      }
    })

    // objectManager.objects

    // objectManager.add(clusterer)

    map.geoObjects.add(objectManager)
    // clusterer.setParent(map)

    map.geoObjects.events.add('click', function (e: any) {
      console.log(e._sourceEvent._sourceEvent._sourceEvent.originalEvent.objectId)
      let target = e.get('target')
      // console.log(target.properties._data.id)
      if (
        !isNullOrUndefined(e._sourceEvent) && 
        !isNullOrUndefined(e._sourceEvent._sourceEvent) && 
        !isNullOrUndefined(e._sourceEvent._sourceEvent._sourceEvent) && 
        !isNullOrUndefined(e._sourceEvent._sourceEvent._sourceEvent.originalEvent) && 
        !isNullOrUndefined(e._sourceEvent._sourceEvent._sourceEvent.originalEvent.objectId) && 
        e._sourceEvent._sourceEvent._sourceEvent.originalEvent.objectId.includes("studio_")
      ) {
        let idx = e._sourceEvent._sourceEvent._sourceEvent.originalEvent.objectId.split("_")[1]
        let exStd = companiesFilter.find(v => v.id == parseInt(idx))
        console.log(exStd, parseInt(idx))
        // if (exStd != undefined) {
        //   studioStore.setSelStudio(exStd)
        // }
        setTimeout(() => {
          setSelectedCompany(prev => prev = null)
          setTimeout(() => {
            setSelectedCompany(prev => prev = exStd)
          }, 100)
        }, 150)
      }
    })
    
  }, [ymaps, listTab, stage, mapRef, isDataLoading, companiesFilter])

  useEffect(() => {
    filterCompanies()
  }, [searchCompany])

  useEffect(() => {
    if (selectedCompany != null) {
      loadBarbers()
    }
  }, [selectedCompany])

  useEffect(() => {
    if (selectedBarber != null) {
      loadBarberServices()
    }
  }, [selectedBarber])

  useEffect(() => {
    if (visible) {
      onOpenRef()
      fetchUser()
    } else {
      onCloseRef()
    }
  }, [visible])

  return (
    <>
      {store.isLocatorVisible ? <Geolocator /> : <></>}

      <div className={styles.modal_shadow + (isWidgetVisible ? " " + styles.visible : "")} style={width > 768 ? {
        display: isWidgetShown ? "block" : "none",
        opacity: isWidgetVisible ? "1" : "0"
      } : {
        display: isWidgetShown ? "block" : "none"
      }}>
        <div className={styles.shadow_zone} onClick={() => onCloseRef()}></div>
        <div className={styles.modal + (stage == 1 ? " " + styles.darken : "")} style={width > 768 ? {
          right: isWidgetVisible ? "0px" : "-520px"
        } : {
          display: isWidgetShown ? "block" : "none",
          // opacity: isWidgetVisible ? "1" : "0",
          top: isWidgetVisible ? "0px" : "100vh"
        }}>
          <div className={styles.container}>
            <div className={styles.topcap}>
              <div className={styles.action_btn + (stage == 0 ? "" : " " + styles.staged)} onClick={() => {
                if (stage == 0) {
                  onClose()
                } else {
                  if (stage == 10) {
                    setStage(prev => prev = 9)
                  } else if (stage == 9) {
                    setStage(prev => prev = 0)
                  } else if (stage == 7 && store.isAuth) {
                    setStage(prev => prev = 5)
                  } else if (stage == 2 && yclients_id != 0) {
                    setStage(prev => prev = 0)
                  } else {
                    setStage(prev => prev = prev - 1)
                  }
                }
              }}>
                <span><i className="fas fa-times"></i></span>
                <span><i className="fas fa-chevron-left"></i></span>
              </div>
              <div className={styles.topcap_title}>Онлайн запись</div>
              {WIDGET_HOST_MODE == "ru" ? <div className={styles.topcap_profile} onClick={() => openUser()}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M224 256c70.7 0 128-57.31 128-128s-57.3-128-128-128C153.3 0 96 57.31 96 128S153.3 256 224 256zM274.7 304H173.3C77.61 304 0 381.6 0 477.3c0 19.14 15.52 34.67 34.66 34.67h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304z"/></svg></div> : <></>}
            </div>

            <div className={styles.tc_power_zone}>
              {stage == 0 || stage == 9 || stage == 10 ? <div className={styles.tcpz_logo}><img style={{}} src={"/assets/images/topgun_plane.png"} /></div> : <></>}
              {stage == 1 ? <div className={styles.tcpz_search}>
                <div className={styles.search_field}>
                  <div><i className="far fa-magnifying-glass"></i></div>
                  <div><DebounceInput debounceTimeout={800} placeholder="Город, адрес, метро" value={searchCompany} onChange={(ev) => setSearchCompany(ev.target.value)} /></div>
                </div>
              </div> : <></>}
              {stage != 0 && stage != 1 && stage != 9 && stage != 8 && selectedCompany != null ? <div className={styles.tcpz_company}>
                <div>{selectedCompany.title}</div>
                <div>{selectedCompany.address}</div>
              </div> : <></>}
            </div>

            <div className={styles.stage + (stage == 0 || stage == 8 || stage == 9 || stage == 10 || stage == 1 ? "" : " " + styles.light)} style={stage == 4 || stage == 5 || stage == 6 ? {backgroundColor: "#fff"} : {}}>
              <div className={styles.stage_loader} style={{
                display: isOrderLoadingShown ? "flex" : "none",
                opacity: isOrderLoadingVisible ? "1" : "0"
              }}><div className={styles.sl_body}><LoadingOutlined rev={null} spin /></div></div>
              
              {/* Начальный экран: создать запись, повторить последнюю запись */}
              {stage == 0 ? <>
                <div className={styles.listing}>
                  <div className={styles.create_order} onClick={() => setTimeout(() => createOrder(), 150)}>
                    <div><i className="far fa-plus"></i></div>
                    <div>Cоздать<br/>онлайн запись</div>
                  </div>

                  {isDtLoading ? <div className={styles.listing_loading}><LoadingOutlined spin rev={null} /></div> : <>
                    {store.actualVisits.filter(v => v.order.reviews.length == 0 && moment(v.order.yclients_data.datetime).unix() > (moment().unix() - 864000)).map(item => <RecordCard item={item} onClick={() => {
                      setTimeout(() => {
                        setSelectedOrder(prev => prev = item)
                        setStage(prev => prev = 9)
                      }, 150)
                    }} onTipsAction={() => {
                      setTimeout(() => {
                        setSelectedOrder(prev => prev = null)
                        setStage(prev => prev = 0)
                      }, 150)
                    }} />)}

                    <h4><span>...</span>Завершенные</h4>
                    {store.actualVisits.filter(v => v.order.reviews.length > 0).map(item => <RecordCard item={item} onClick={() => {
                      setTimeout(() => {
                        setSelectedOrder(prev => prev = item)
                        setStage(prev => prev = 9)
                      }, 150)
                    }} onTipsAction={() => {
                      setTimeout(() => {
                        setSelectedOrder(prev => prev = item)
                        setStage(prev => prev = 9)
                      }, 150)
                    }} />)}
                  </>}
                </div>
              </> : <></>}

              {/* Выбор филиала + поиск по городу/адресу/метро */}
              {stage == 1 ? <>
                {isDataLoading ? <div className={styles.loading}><LoadingOutlined rev={null} spin /></div> : <></>}

                <div className={styles.servs_tabs + (listTab == 1 ? " " + styles.active2 : "")}>
                  <div onClick={() => setListTab(0)}><span>Список</span></div>
                  <div onClick={() => setListTab(1)}><span>На карте</span></div>
                </div>

                {!isDataLoading && companiesFilter.length > 0 && listTab == 0 ? <div className={styles.listing}>
                  {companiesFilter.map(item => <CompanyCard theme="dark" item={item} onClick={() => {
                    setTimeout(() => {
                      setSelectedCompany(prev => prev = null)
                      setTimeout(() => {
                        setSelectedCompany(prev => prev = item)
                      }, 100)
                    }, 150)
                  }} />)}
                </div> : <></>}

                {!isDataLoading && listTab == 1 ? <>
                  <div className={styles.mapbox} ref={mapRef}></div>
                </> : <></>}
              </> : <></>}

              {/* Выбор барбера с пре-выводом ближайших дат работы */}
              {stage == 2 ? <>
                {isDataLoading ? <div className={styles.loading}><LoadingOutlined rev={null} spin /></div> : <></>}
                {!isDataLoading && barbers.length > 0 ? <div className={styles.listing}>
                  {barbers.map(item => <BarberCard item={item} onClick={() => {
                    setTimeout(() => {
                      setSelectedBarber(prev => prev = null)
                      setSelectedServices(prev => prev = [])
                      setTimeout(() => {
                        setSelectedBarber(prev => prev = item)
                      }, 100)
                    }, 150)
                  }} />)}
                </div> : <></>}
              </> : <></>}

              {/* Выбор услуг */}
              {stage == 3 ? <>
                {/* <div className={styles.servs_tabs + (servsTab == 1 ? " " + styles.active2 : "")}>
                  <div onClick={() => setServsTab(0)}><span>Все</span></div>
                  <div onClick={() => setServsTab(1)}><span>Бонусные</span></div>
                </div> */}

                {/* {!isGiftSelected() && loyaltyStore.myStatus.name != "start" ? <div className={styles.compliment} onClick={() => {
                  selectGift()
                }}>
                  <div onClick={(ev) => {
                    prevent(ev)
                    setIsCompInfoVisible(true)
                  }}><IconsPack name="far fa-circle-info" /></div>
                  <div>{selectedPrize != null ? <><b>+ {selectedPrize.name}</b> за <b>0<RubbleIcon /></b></> : "Выбрать комплимент"}</div>
                  <div><IconsPack name="fas fa-chevron-right" /></div>
                </div> : <></>} */}

                {isDataLoading ? <div className={styles.loading}><LoadingOutlined rev={null} spin /></div> : <></>}
                {!isDataLoading && services.length > 0 ? <div className={styles.listing}>
                  {services.filter(v => isServiceSelected(v)).sort((a: any, b: any) => {
                    return a.weight > b.weight ? -1 : (a.weight < b.weight ? 1 : 0)
                  }).map(item => <ServiceCard 
                    item={item} 
                    selected={isServiceSelected(item)}
                    onSelect={(serv: any) => {
                      selectService(serv)
                    }}
                    onClick={() => {
                      // setSelectedServices(prev => prev = item)
                    }} />)}
                  {services.filter(v => !isServiceSelected(v)).sort((a: any, b: any) => {
                    return a.weight > b.weight ? -1 : (a.weight < b.weight ? 1 : 0)
                  }).map(item => <ServiceCard 
                    item={item} 
                    selected={isServiceSelected(item)}
                    onSelect={(serv: any) => {
                      selectService(serv)
                    }}
                    onClick={() => {
                      // setSelectedServices(prev => prev = item)
                    }} />)}
                </div> : <></>}

                <div className={styles.bottom_action}>
                  <div className={styles.action + (selectedServices.length == 0 ? " " + styles.disabled : "")} onClick={() => selectedServices.length == 0 ? false : setTimeout(() => goCalendar(), 150)}>
                    <div>{selectedServices.length} {declOfNum(selectedServices.length, ["услуга", "услуги", "услуг"])}</div>
                    <div>Продолжить</div>
                    <div>{getTotalPrice()} <RubbleIcon /></div>
                  </div>
                </div>
              </> : <></>}

              {/* Выбор даты по календарю - в радиусе двух месяцев */}
              {stage == 4 ? <>
                {isDataLoading ? <div className={styles.loading}><LoadingOutlined rev={null} spin /></div> : <></>}
                {!isDataLoading ? <div className={styles.listing}>
                  <Calendar 
                    available={availableDates} 
                    onSelectDate={(ev) => goTimetable(ev)} />
                </div> : <></>}
              </> : <></>}

              {/* Выбор времени записи */}
              {stage == 5 ? <>
                {isDataLoading ? <div className={styles.loading}><LoadingOutlined rev={null} spin /></div> : <></>}
                {!isDataLoading ? <>
                  <div className={styles.listing}>
                    <div className={styles.times_title}><b>{selectedDateStr2}</b>, {selectedDateStr}</div>
                    <div className={styles.times_table}>
                      {availableTimes.map((row: any) => <div className={styles.tt_row} style={{justifyContent: row.length == 5 ? "space-between" : "space-between"}}>
                        {row.map((time: any) => <div className={styles.tt_time} style={time.time == "--:--" ? {
                          pointerEvents: "none", userSelect: "none", opacity: "0"
                        } : {}} onClick={() => goFinal(time)}><span>{time.time}</span></div>)}
                      </div>)}
                    </div>
                  </div>
                </> : <></>}
              </> : <></>}

              {stage == 6 ? <>
                <div className={styles.xform}>
                  <div className={styles.xform_field}>
                    <label htmlFor="user_name">Ваше Имя</label>
                    <input type="text" placeholder="Иван" value={userName} onChange={(ev) => setUserName(ev.target.value)} />
                    <small>Необязательно</small>
                  </div>
                  <div className={styles.xform_field}>
                    <label htmlFor="user_name">Ваш телефон</label>
                    <InputMask disabled={WIDGET_HOST_MODE == "plus"} autoComplete="off" mask="+7 999 999-99-99" maskChar="_" placeholder="+7 ___ ___-__-__" value={userPhone} onChange={(event) => setUserPhone(event.target.value)} />
                    <small className={isUserPhoneError ? styles.red : ""}>Обязательно</small>
                  </div>
                  <div className={styles.xform_field}>
                    <label htmlFor="user_name">Ваш Email</label>
                    <input type="email" placeholder="example@topgun.ru" value={userEmail} onChange={(ev) => setUserEmail(ev.target.value)} />
                    <small>Необязательно</small>
                  </div>
                </div>
                
                <div className={styles.bottom_action}>
                  <div className={styles.action} onClick={() => saveUserData()}>
                    <div></div>
                    <div>{isUserPhoneLoading ? <LoadingOutlined spin rev={null} /> : "Продолжить"}</div>
                    <div></div>
                  </div>
                </div>
              </> : <></>}

              {/* Моя запись с подробностями, завершение записи. Напоминание? */}
              {stage == 7 ? <>
                <div className={styles.listing}>
                  <div className={styles.final_card}>
                    <div className={styles.title}>Моя запись</div>
                    <div className={styles.params}>
                      {loyaltyUser != null ? <div className={styles.p_param}>
                        <div>Карта лояльности</div>
                        <div>{loyaltyUser.card}</div>
                      </div> : <></>}
                      <div className={styles.p_param}>
                        <div>{loyaltyUser != null ? "Клиент" : "Гость"}</div>
                        <div>{loyaltyUser != null ? loyaltyUser.name : userName}</div>
                      </div>
                      <div className={styles.p_param}>
                        <div>Мобильный</div>
                        <div>{loyaltyUser != null ? loyaltyUser.phone : userPhone}</div>
                      </div>
                      <div className={styles.p_param}>
                        <div>Дата</div>
                        <div>{selectedDateStr}, {selectedDateStr2}</div>
                      </div>
                      <div className={styles.p_param}>
                        <div>Время</div>
                        <div>{selectedTime.time}</div>
                      </div>
                      <div className={styles.p_param}>
                        <div>Сотрудник</div>
                        <div>{selectedBarber.name} ({selectedBarber.specialization})</div>
                      </div>
                    </div>
                    <div className={styles.services}>
                      {selectedServices.map(srv => <div className={styles.s_serv}>
                        <div>{srv.title}</div>
                        <div>{getServicePrice(srv)} <RubbleIcon /></div>
                      </div>)}
                      {selectedPrize != null ? <div className={styles.s_serv}>
                        <div>{selectedPrize.name}</div>
                        <div>0 <RubbleIcon /></div>
                      </div> : <></>}
                    </div>
                    <div className={styles.total}>
                      <div>Итого</div>
                      <div>{getTotalPrice()} <RubbleIcon /></div>
                    </div>
                  </div>

                  <div className={styles.option_check}>
                    <Checkbox checked={isAccepted} onChange={(ev) => setIsAccepted(ev.target.checked)}>Я предоставляю согласие на <a href="https://topgun.plus/uploads/yclients_policy.docx" target="_blank">обработку своих персональных данных</a> ООО УК ТОПГАН (или организации ИНН 7810935037)</Checkbox>
                  </div>
                </div>

                <div className={styles.bottom_action}>
                  <div className={styles.action + " " + styles.green} onClick={() => createYCLOrder()}>
                    <div></div>
                    <div>Записаться</div>
                    <div></div>
                  </div>
                </div>
              </> : <></>}

              {stage == 8 ? <>
                {isSendCodeLoading ? <>
                  <div className={styles.xload}>
                    <div><LoadingOutlined spin rev={null} /></div>
                    <div>Создаем запись...</div>
                  </div>
                </> : <>
                  <div className={styles.xcode}>
                    <label htmlFor="">Код из {whatSmsGet == "sms" ? "СМС" : "Telegram"}</label>
                    {/* <input type="text" placeholder="0000" value={userCode} onChange={(ev) => setUserCode(ev.target.value)} /> */}
                    <InputMask disabled={isSignLoading} autoComplete="off" mask="9999" maskChar="_" placeholder="____" value={userCode} onChange={(ev) => setUserCode(ev.target.value)}  />
                  </div>

                  <div className={styles.bottom_action + " " + styles.invert}>
                    <div className={styles.action} onClick={() => signInAction()}>
                      <div></div>
                      <div>{isSignLoading ? <LoadingOutlined spin rev={null} /> : "Продолжить"}</div>
                      <div></div>
                    </div>
                  </div>
                </>}
              </> : <></>}

              {stage == 10 && selectedOrder != null ? <>
                <div className={styles.review}>
                  <div className={styles.joegun}></div>
                  {barber != null ? <div className={styles.barber}>
                    <div style={{backgroundImage: `url(${barber.avatar})`}}></div>
                    <div>
                      <span>{barber.name} <b><i className="fas fa-star"></i> {barber.rating}</b></span>
                      <span>{barber.specialization}</span>
                    </div>
                  </div> : <></>}

                  <div className={styles.tips}>
                    {loyaltyBarber == null ? <div className={styles.tips_shader}><b>У барбера нет аккаунта лояльности</b></div> : <></>}
                    <div className={styles.tips_title}>Оставить чаевые барберу <span onClick={() => setTipsInfoVisible(true)}>Как это работает?</span></div>
                    <div className={styles.tips_values}>
                      <div className={tipsCount == 0 ? styles.active : ""} onClick={() => setTipsCount(0)}>0<small><RubbleIcon /></small></div>
                      <div className={tipsCount == 500 ? styles.active : ""} onClick={() => setTipsCount(500)}>500<small><RubbleIcon /></small></div>
                      {/* <div>50<small><RubbleIcon /></small></div> */}
                      <div className={tipsCount == 1000 ? styles.active : ""} onClick={() => setTipsCount(1000)}>1000<small><RubbleIcon /></small></div>
                      <div className={tipsCount == 2000 ? styles.active : ""} onClick={() => setTipsCount(2000)}>2000<small><RubbleIcon /></small></div>
                      {/* <div classNamex={tipsCount == -1 ? styles.active : ""} onClick={() => setTipsCount(-1)}>своя сумма</div> */}
                      {/* <div className={tipsInfoVisible ? styles.active : ""} onClick={() => setTipsInfoVisible(true)}><i className="far fa-circle-info"></i></div> */}
                    </div>
                    <div className={styles.tips_input} style={{height: tipsCount == -1 ? "40px" : "0px"}}>
                      {/* <input type="number" placeholder="0" value={tipsCountTxt} onChange={(ev) => setTipsCountTxt(ev.target.value)} /> */}
                      {/* <span>бон. руб.</span> */}
                      <p>Большую сумму чаевых вы можете оставить наличными барберу</p>
                    </div>
                  </div>

                  <div className={styles.stars}>
                    <div className={styles.title}>Ваша оценка барберу</div>
                    <Rate allowHalf={true} value={rate} onChange={(ev) => setRate(prev => prev = ev)} style={{fontSize: "52px", lineHeight: "52px"}} />
                  </div>
                  <div className={styles.comment}>
                    <div className={styles.title}>Ваш отзыв</div>
                    <textarea name="order_review" id="order_review" rows={3} value={comment} onChange={(ev) => setComment(ev.target.value)}></textarea>
                  </div>

                  <div className={styles.action}>
                    <button disabled={isSendingReview} onClick={() => sendReview()}>Продолжить</button>
                  </div>
                </div>
              </> : <></>}
              
              {stage == 9 && selectedOrder != null ? <>
                <div className={styles.order_view}>
                  <div className={styles.joegun}></div>
                  <div className={styles.ov_block}>
                    <div>{moment(selectedOrder.result.data.datetime).format("DD MMMM")}</div>
                    <div>Время {moment(selectedOrder.result.data.datetime).format("HH:mm")}</div>
                  </div>
                  <div className={styles.ov_block}>
                    <div>{selectedOrder.company.data.title}</div>
                    <div>{selectedOrder.company.data.address}</div>
                  </div>
                  <div className={styles.ov_block}>
                    <div>{selectedOrder.result.data.staff.name} ({selectedOrder.result.data.staff.specialization})</div>
                    <div>Сотрудник</div>
                  </div>
                  <div className={styles.ov_services} style={{marginBottom: "0px"}}>
                    {selectedOrder.result.data.services.slice(0, 2).map(v => <div className={styles.ov_s__item}>
                      <div>{v.title}</div>
                      <div>{v.cost_to_pay} <RubbleIcon /></div>
                    </div>)}
                    {selectedOrder.result.data.services.length > 2 ? <div className={styles.ov_services__more} onClick={() => setServsInfoVisible(true)}>...</div> : ""}
                    <div className={styles.ov_s__item}>
                      <div>Итого</div>
                      <div>{getTotalPriceBS(selectedOrder.result.data.services)} <RubbleIcon /></div>
                    </div>
                  </div>
                  <div className={styles.ov_services} style={{marginTop: "0px"}}>
                    <div className={styles.ov_s__item}>
                      <div>Чаевые</div>
                      <div>{selectedOrder.order.tips.length > 0 ? selectedOrder.order.tips[0].count : 0} <RubbleIcon /></div>
                    </div>
                  </div>

                  {selectedOrder.order.reviews.length > 0 ? <div className={styles.ov_review}>
                    <div>Ваш отзыв</div>
                    <div><i className="fas fa-star"></i> {selectedOrder.order.reviews[0].rating.toFixed(1)}</div>
                    <div>{selectedOrder.order.reviews[0].review}</div>
                  </div> : <></>}

                  <div className={styles.ov_actions}>
                    {selectedOrder.order.reviews.length > 0 ? <button onClick={() => {
                      setStage(prev => prev = 0)
                      setSelectedOrder(prev => prev = null)
                    }}>Отлично</button> : <></>}
                    {isOrderEnded() && selectedOrder.order.reviews.length == 0 ? <button onClick={() => {
                      fetchBarber()
                    }}>Оставить отзыв и чаевые</button> : <></>}
                    {!isOrderStarted() ? <button className={styles.cancel} onClick={() => {
                      setIsOrderCancelVisible(prev => prev = true)
                    }}>Отменить запись</button> : <></>}
                  </div>
                </div>
              </> : <></>}
            </div>
          </div>
        </div>
      </div>
      
      <BottomModal
        prePreVisible={prePreVisible}
        preVisible={preVisible}
        visible={visibleA}
        onClose={() => {
          closeUser()
        }}
        title=""
        content={store.isAuth ? <>
          <div className={styles.head_toolbox}>
            <div onClick={() => closeUser()}><i className="fas fa-xmark"></i></div>
            <div onClick={() => logout()}><i className="fas fa-right-from-bracket"></i></div>
          </div>
          <div className={styles.user_profile}>
            <div className={styles.up_avatar} style={{backgroundImage: `url(${store.userData.avatar})`}}></div>
            <div className={styles.up_data}>
              <span>{store.userData.name} {store.userData.surname}</span>
              <span>{store.userData.phone}</span>
            </div>
          </div>
          {bonusCard != null ? <>
            <div className={styles.ul_title}>Лояльность</div>
            <div className={styles.user_loyalty} style={{backgroundImage: `url(/assets/images/bonus_card_x.jpg)`}} onClick={() => {
              if (WIDGET_HOST_MODE == "plus") {
                closeUser()
                onClose()
                onOpenSubscribe()
              } else {
                window.open("https://topgun.plus/store", "_blank")
              }
            }}>
              <div className={styles.ul_sub}>{activeSub != null ? getSubName(activeSub.sub_name) : "Не подключена"}</div>
              <div className={styles.ul_bon_ttl}>На счету</div>
              <div className={styles.ul_bon}>{bonuses} <RubbleIcon /></div>
              <div className={styles.ul_card} onClick={() => {
                navigator.clipboard.writeText(bonusCard.card_number)
                message.success("Номер карты скопирован")
              }}>{bonusCard.card_number}</div>
              <div className={styles.ul_arr}><i className="far fa-arrow-right"></i></div>
            </div>
          </> : <></>}
          <div className={styles.home_button}>
            <div><i className="fas fa-clock-rotate-left"></i></div>
            <div>
              <span>История посещений</span>
            </div>
            <div><i className="fas fa-chevron-right"></i></div>
          </div>
        </> : <>
          <div className={styles.auth_form}>
            {authState == "phone" ? <div className={styles.af_input}>
              <label htmlFor="user_phone">Номер телефона</label>
              <InputMask id="user_phone" name="user_phone" mask="+7 999 999 99 99" maskChar="_" placeholder="+7 977 333-06-99" value={phone} onChange={(event) => setPhone(event.target.value)} />
            </div> : <div className={styles.af_input}>
              <label htmlFor="code">Код из {whatSmsGet == "telegram" ? "Telegram" : "смс"}</label>
              <input id="code" name="code" placeholder="****" value={code} onChange={(event) => setCode(event.target.value)} />
            </div>}
            <div className={styles.af_action}>
              <button onClick={() => authState == "phone" ? sendCode() : signIn()}>{authState == "phone" ? "Продолжить" : "Войти"}</button>
            </div>
          </div>
        </>} />

      <ConfirmModal
        visible={servsInfoVisible}
        onClose={() => setServsInfoVisible(false)}
        title="Услуги"
        content={selectedOrder != null ? <>
          <div className="cmodal_text">
            <div className={styles.ov_services} style={{marginBottom: "0px"}}>
              {selectedOrder.result.data.services.map(v => <div className={styles.ov_s__item}>
                <div>{v.title}</div>
                <div>{v.cost_to_pay} <RubbleIcon /></div>
              </div>)}
              <div className={styles.ov_s__item}>
                <div>Итого</div>
                <div>{getTotalPriceBS(selectedOrder.result.data.services)} <RubbleIcon /></div>
              </div>
            </div>
          </div>
          <div className="cmodal_action">
            <div>
              <button onClick={() => setServsInfoVisible(false)}>Закрыть</button>
            </div>
          </div>
        </> : <></>} />

      <Modal
        visible={tipsInfoVisible}
        onClose={() => setTipsInfoVisible(false)}
        title="Как работают чаевые?"
        content={<>
          <div className="modal_text">
            <p>Оставить чаевые можно только если и у клиента и у барбера есть аккаунт лояльности TOPGUN+<br/><br/>Клиент может отправить барберу любую сумму бонусных рублей внутри системы в качестве чаевых</p>
          </div>
          <div className="modal_action">
            <div>
              <button onClick={() => setTipsInfoVisible(false)}>Понятно</button>
            </div>
          </div>
        </>} />

      <ConfirmModal
        visible={isOrderCreateVisible}
        onClose={() => setIsOrderCreateVisible(false)}
        title="Подтвердить запись"
        content={selectedCompany != null && selectedTime != null ? <>
          <div className="cmodal_text">
            <p>Вы действительно хотите записаться в <b>{selectedCompany.title}</b> на <b>{selectedDateStr}, {selectedDateStr2}, {selectedTime.time}</b>?</p>
          </div>
          <div className="cmodal_action">
            <div>
              <button onClick={() => !store.isAuth && WIDGET_HOST_MODE == "ru" ? sendCodeAction() : createYCLOrderAction()}>Записаться</button>
            </div>
          </div>
        </> : <></>} />

      <ConfirmModal
        visible={isOrderCancelVisible}
        onClose={() => setIsOrderCancelVisible(false)}
        title="Отменить запись"
        content={<>
          <div className="cmodal_text">
            <p>Вы действительно хотите отменить эту запись?</p>
          </div>
          <div className="cmodal_action">
            <div>
              <button onClick={() => declineOrder()}>Отменить</button>
            </div>
          </div>
        </>} />

      <ConfirmModal
        visible={isLogoutVisible}
        onClose={() => setIsLogoutVisible(false)}
        title="Выйти из аккаунта"
        content={<>
          <div className="cmodal_text">
            <p>Вы действительно хотите выйти из аккаунта TOPGUN+?</p>
          </div>
          <div className="cmodal_action">
            <div>
              <button onClick={() => logoutAction()}>Выйти</button>
            </div>
          </div>
        </>} />

    </>
  )
}

export default observer(YClientsWidget)